export default __webpack_public_path__ + "battery-icon.png";